<template>
    <div v-if="isURL || isLongText" class="d-flex align-items-center">
        <a v-if="isURL" :href="safeText" target="_blank" class="text-truncate">{{ safeText }}</a>
        <div v-else class="text-truncate">{{ safeText }}</div>
        <Icon name='copy' class="c18 ml8 pointer" @click="copy(safeText)"/>
    </div>
    <div v-else-if="isSum" class="d-flex align-items-center">
        <div class="neue text-truncate" :class="{ 'fsp14': isMobile, 'fsp16 lh24': !isMobile }">
            <span>
                <span class="neue">{{ sumParts.integer }}</span>
                <span v-if="sumParts.fraction" class="primary-grey" :class="{ 'fsp10': isMobile, 'fsp12': !isMobile }">.{{ sumParts.fraction }}</span>
            </span>&nbsp;
        </div>
        <div v-if="sumParts.ticker" class="neue primary-grey text-truncate lh16" :class="{ 'fsp14': isMobile, 'fsp16': !isMobile }">{{ sumParts.ticker }}</div>
    </div>
    <div v-else>{{ safeText }}</div>
</template>

<script>
import Icon from '@/components/icons/Icon';

export default {
    name: 'Text',
    components: {
        Icon
    },
    props: {
        text: {
            type: [String, Number],
            default: ''
        },
        isSum: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        copy(text) {
            this.$lib.copyTextS(text, this.$store)
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        },
        safeText() {
            return String(this.text ?? '');
        },
        sumParts() {
            const [amount = '', ticker = ''] = this.safeText.split(' ');
            const [integer = '', fraction = ''] = amount.split('.');
            return { integer, fraction, ticker };
        },
        isLongText() {
            return /^[^\s.]{25,}$/.test(this.safeText);
        },
        isURL() {
            try {
                new URL(this.safeText);
                return true;
            } catch (error) {
                return false;
            }
        }
    }
}
</script>
